<div class="login" *ngIf="!loading">
    <div class="animated fadeInRight" *ngIf="!loading">
        <div class="app-body">
            <main class="main d-flex align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-10 col-md-8 mx-auto">
                            <div class="card-group border border-warning">
                                <div class="card text-black-50 bg-light border-warning py-5 d-md-down-none"
                                    style="width:100%">
                                    <div class="card-body text-center">
                                        <div>
                                            <object>
                                                <embed src="../../../../../assets/images/logo/lafabril-logo-medium.svg">
                                            </object>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-warning p-4">
                                    <div class="card-body">
                                        <form [formGroup]="formulario" novalidate class="form-group" (ngSubmit)="onCambiarClave()">
                                            <h3 class="card-title">Cambiar Contraseña</h3>
                                            <p class="text-muted" *ngIf="firstName || login">Hola {{ firstName }} ({{ login }})</p>
                                            <p class="text-muted">Ingrese su nueva contraseña</p>

                                            <div class="input-group mb-4 mt-4">
                                                <span class="input-group-text"> <i class="fa fa-key"
                                                        aria-hidden="true"></i> </span>
                                                <input class="form-control" type="password"
                                                    placeholder="Nueva Contraseña" formControlName="newPassword">
                                            </div>
                                            <small class="text-danger d-block mb-3" *ngIf="formulario.get('newPassword')?.touched && formulario.get('newPassword')?.invalid">
                                                {{ getPasswordError() }}
                                            </small>

                                            <div class="input-group mb-2">
                                                <span class="input-group-text"> <i class="fa fa-key"
                                                        aria-hidden="true"></i> </span>
                                                <input class="form-control" type="password"
                                                    placeholder="Confirmar Contraseña" formControlName="confirmPassword">
                                            </div>
                                            <small class="text-danger d-block mb-3" *ngIf="formulario.get('confirmPassword')?.touched && formulario.hasError('passwordMismatch')">
                                                {{ getPasswordMismatchError() }}
                                            </small>

                                            <div class="password-requirements mb-3">
                                                <p class="text-muted small mb-1">La contraseña debe contener:</p>
                                                <ul class="small text-muted">
                                                    <li>Al menos 8 caracteres</li>
                                                    <li>Una letra mayúscula</li>
                                                    <li>Una letra minúscula</li>
                                                    <li>Un número</li>
                                                    <li>Un carácter especial (!&#64;#$%^&amp;*(),.?":&#123;&#125;|&lt;&gt;)</li>
                                                </ul>
                                            </div>

                                            <div class="row">
                                                <div class="col-6">
                                                    <button type="submit" class="btn btn-outline-warning px-4 ngcl"
                                                        [disabled]="formulario.invalid">Cambiar</button>
                                                </div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <a (click)="volverAlLogin()" style="cursor: pointer;">Volver al Login</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</div>

<div class="containerLoader" *ngIf="loading">
    <div class="item-1"></div>
    <div class="item-2"></div>
    <div class="item-3"></div>
    <div class="item-4"></div>
    <div class="item-5"></div>
</div>
